module.exports = __webpack_public_path__ + "img/product-preview-19.f02ad36.png";